import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AiImage } from 'app/library/image-library/models/ai-image.model';
import { IModuleImageQuery } from 'app/library/module/interfaces/module-image.interface';
import { ModuleImage } from 'app/library/module/models/module-image.model';
import { ModuleService } from 'app/library/module/services/module.service';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { AiImageUploadCommand } from 'app/projects/user/src/lib/models/ai-image-upload.command';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AiCreatedImageApiService {
    private apiUrl: string;
    private entities: string;

    constructor(private http: HttpClient, public moduleFormService: ModuleService, @Inject(MAXBRAIN_ENVIRONMENT) { apiUrl }: IEnvironment) {
        this.apiUrl = apiUrl;
        this.entities = 'cil/ai-generated';
    }

    generateImage(prompt: string): Promise<AiImage> {
        return this.http
            .post<{ image: string }>(`${this.apiUrl}/${this.entities}/images`, { prompt })
            .pipe(map((query) => new AiImage(query)))
            .toPromise();
    }

    uploadImage(croppedImage: File, selectedImage: File): Observable<any> {
        const data = new AiImageUploadCommand(croppedImage, selectedImage, null).formData;
        return this.http.post<IModuleImageQuery>(`${this.apiUrl}/${this.entities}/upload`, data).pipe(map((query) => new ModuleImage(query)));
    }
}
